





















import { GPageBase } from '@/mixins';
import { mixins } from 'vue-class-component';
import { Component, Prop } from 'vue-property-decorator';
import GExamCreateFormFormat from '../GExamCreateFormFormat.vue';
import { evalSettingModule } from '@/store/modules/entities/eval-setting.module';
import { EvalSetting } from '@/models/evalSetting/eval-setting';
import GVTag from '@/components/GVTag.vue';
import { EvalSettingMail } from '@/models/evalSetting/eval-setting-mail';
import { globalModule } from '@/store/modules/global.module';
import moment from 'moment';

@Component({
  name: 'GExamCreateMailSettingDate',
  components: { GVTag, GExamCreateFormFormat },
  computed: {},
  methods: {},
})
export default class GExamCreateMailSettingDate extends mixins(GPageBase) {
  @Prop() mailDate: Date;
  @Prop() index: number;

  mounted() {}

  get evalSettingDetail(): EvalSetting {
    return evalSettingModule.evalSettingDetail;
  }

  get mailSetting(): EvalSettingMail {
    return this.evalSettingDetail.mailSetting;
  }

  get mailSettingDates(): Date[] {
    return this.mailSetting.dates;
  }

  // iviewのDatePickerのoptionsに入れるオブジェクト
  get dateOption() {
    const startDate: Date = globalModule.isNewSchoolYear ? new Date(globalModule.selectedSchoolYear, 3, 1) : new Date();
    const endDate : Date = new Date(globalModule.selectedSchoolYear + 1, 3, 1);
    const startDateMoment = moment(startDate);
    const endDateMoment = moment(endDate);
    return {
      disabledDate(date: Date) {
        // 開始日（startDate）より以前、終了日（endDate）より以降であれば true を返す => disabled
        // 「開始日以前」または「終了日以降」であれば選択不可
        return (date && moment(date).isBefore(startDateMoment, 'day') || moment(date).isSameOrAfter(endDateMoment, 'day'));
      },
    };
  }

  get isInvalid(): boolean {
    return this.mailSettingDates[this.index] === null;
  }

  /**
   * 時間設定
   */
  handleSetDate(value: string) {
    const date = value === '' ? null : moment(value).toDate();
    this.mailSettingDates.splice(this.index, 1, date);
  }

  handleDelete(index: number) {
    this.mailSettingDates.splice(this.index, 1);
  }
}
